import { Component, OnInit, HostListener, PLATFORM_ID, Inject, OnDestroy } from '@angular/core';
import { CommonModule, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ROUTES, ActiveSectionService } from '@public/core';
import { Subscription } from 'rxjs';
import { Renderer2 } from '@angular/core';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  isMenuOpen = false;
  isScrolled = false;
  private scrollSubscription!: Subscription;
  activeSection = this.activeSectionService.activeSection;

  readonly ROUTES = ROUTES;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    public router: Router,
    private viewportScroller: ViewportScroller,
    private renderer: Renderer2,
    private activeSectionService: ActiveSectionService,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScroll();
    }
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    if (isPlatformBrowser(this.platformId)) {
      this.isScrolled = window.scrollY > 50;
    }
  }

  scrollToTop(): void {
    if (this.router.url !== '/') {
      this.router.navigate(['/']).then(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      });
    } else {
      if (isPlatformBrowser(this.platformId)) {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    }
    this.closeMenu();
  }

  scrollToFragment(fragment: string): void {
    this.closeMenu();
    if (this.router.url === '/') {
      this.viewportScroller.scrollToAnchor(fragment);
    } else {
      this.router.navigate(['/']).then(() => {
        setTimeout(() => this.viewportScroller.scrollToAnchor(fragment), 100); // Allow time for navigation
      });
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.toggle('menu-open', this.isMenuOpen);
    }
  }

  closeMenu() {
    if (this.isMenuOpen) {
      this.isMenuOpen = false;
      if (isPlatformBrowser(this.platformId)) {
        document.body.classList.remove('menu-open');
      }
    }
  }

  ngOnDestroy(): void {
    if (this.scrollSubscription) {
      this.scrollSubscription.unsubscribe();
    }
  }
}
